<template>
    <div class="tabPageDiv">
            <a href="javascript:;"
               class="tabPageA pageRoll"
               @click="frontClick(currentPage-1,newsType)"
            >
                上一页
            </a>

            <a href="javascript:;" class="tabPageA"
               v-for="(item, index) in showingPage"
               :key="index"
               :class="currentPage==item ? 'pageActive':''"
               @click="changeCurrentPage(item,newsType)"
            >
            {{ item }}
            </a>

            <a href="javascript:;"
               class="tabPageA pageRoll"
               @click="nextClick(currentPage+1,newsType)"
            >
                下一页
            </a>
    </div>
</template>
<script type="text/javascript">
export default {
    props: {
        totalPage: {
            type: Number,
            required: true
        },
        newsType: {type:String},
        currentPage: {type:Number}
    },
    data() {
        return {
            actPage: []
        }
    },
    computed: {
        showingPage:{
            get(){
                let pages = []
                let n = 5 //限制用户一次性看到n页，下称限制页数

                if(this.totalPage < n){
                    /* 总页数<限制页数 展示总页数*/
                    for(let i=0;i<this.totalPage;i++){
                        pages.push(i+1)
                    }

                }else{
                    /* 总页数>=限制页数 展示限制页数*/
                    for(let i=0;i<n;i++){
                        pages.push(i+1)
                    }

                }

                return pages
            },

            set(p){
                return p
            }
            
        },

    },
    methods: {
        changeCurrentPage(page,type) {
            if (page <= 0 || page > this.totalPage || page==='...') {
                return
            }
            // this.type = type
            // console.log("子：page组件里收到的type",type)
            // console.log("子：type类型",typeof type)
            this.$emit('changePage',page,type)
        },
        frontClick(page,type) {
            // console.log("front click type",type)

            let pages = this.actPage.length?this.actPage:this.showingPage

            // 若限制 n=5
            // 点击上一页 且当前页page>0
            // 则从[2,3,4,5,6]变成[1,2,3,4,5]
            if(page>0){
                if(pages[0] != 1){
                    let a = pages[0] - 1
                    pages.unshift(a)
                    pages.pop()
                    this.showingPage = pages
                    this.actPage = this.showingPage
                }

                this.$emit('changePage',page,type)
            }
            
        },
        nextClick(page,type) {
            let pages = this.actPage.length?this.actPage:this.showingPage

            // 若限制 n=5
            // 点击下一页 且当前页page不超出totalPage
            // 则从[1,2,3,4,5]变成[2,3,4,5,6]
            if(page<=this.totalPage){
                let len = pages.length

                if(pages[len-1] != this.totalPage){
                    let a = pages[len-1] + 1
                    pages.push(a)
                    pages.shift()
                    this.showingPage = pages
                    this.actPage = this.showingPage
                }

                this.$emit('changePage',page,type)
            }
            
        },
    }
}
</script>

<style lang="scss" scoped>
.tabPageDiv {
    display: flex;
    justify-content: center;
    margin: vw(16) 0 vw(44);

    .tabPageA {
        display: block;
        font-size: vw(14);
        height: vw(35);
        width: vw(35);
        margin: 0 vw(6);
        padding: vw(8);
        font-weight: 500;
        color: $yyBlue;
        background: #fff;
        border: 1px solid $yyBlue;
        border-radius: 50%;
        box-sizing: border-box;
    }

    .pageRoll{
        height: vw(38);
        width: vw(80);
        border-radius: vw(19);
    }

    .tabPageA:hover, 
    .pageActive{
        color: #fff;
        background: $yyBlue;
    }
}



</style>